import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import {
  colDateFormat,
  enquiryStatus,
  eventTypes,
  regionTypes,
} from '../../Constants';
import LocalisedDatePicker from '../Common/LocalisedDatePicker';
import LocalisedTimePicker from '../Common/LocalisedTimePicker';
import dayjs, { Dayjs } from 'dayjs';
import { ArtistPrice } from '../../@types/api';

const sxProps = {
  detailRow: {
    pt: 2,
  },
  formControl: {
    m: 1,
    minWidth: 250,
  },
};

interface Props {
  data: any;
  status: string;
  eventType: string;
  location: string;
  venueName: string;
  priceType: keyof ArtistPrice;
  eventDate: Dayjs | null;
  startTime: Dayjs | null;
  endTime: Dayjs | null;
  setStatus: (value: string) => void;
  setEventType: (value: string) => void;
  setLocation: (value: string) => void;
  setVenueName: (value: string) => void;
  setPriceType: (value: keyof ArtistPrice) => void;
  setEventDate: (value: Dayjs | null) => void;
  setStartTime: (value: Dayjs | null) => void;
  setEndTime: (value: Dayjs | null) => void;
}
const SetUp: React.FC<Props> = ({
  data,
  status,
  eventType,
  venueName,
  location,
  priceType,
  eventDate,
  startTime,
  endTime,
  setStatus,
  setEventType,
  setLocation,
  setVenueName,
  setPriceType,
  setEventDate,
  setStartTime,
  setEndTime,
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item>
        <div>
          <Typography variant='body1' sx={sxProps.detailRow}>
            <strong>DateCreated:</strong>{' '}
            {dayjs(data.enquiry.createdWhen).format(colDateFormat)}
          </Typography>
          <Typography variant='body1' sx={sxProps.detailRow}>
            <strong>Client ID:</strong> {data.enquiry.clientId}
          </Typography>
          <Typography variant='body1' sx={sxProps.detailRow}>
            <strong>Client Name:</strong> {data.enquiry.firstName}{' '}
            {data.enquiry.surname}
          </Typography>
          <Typography variant='body1' sx={sxProps.detailRow}>
            <strong>Email:</strong> {data.enquiry.emailAddress}
          </Typography>
          <Typography variant='body1' sx={sxProps.detailRow}>
            <strong>Comments:</strong> {data.enquiry.comments}
          </Typography>
        </div>
      </Grid>
      <Grid item>
        <div>
          <FormControl sx={sxProps.formControl}>
            <InputLabel id='status'>Status</InputLabel>
            <Select
              labelId='status'
              id='status-label'
              value={status}
              label='Status'
              onChange={(event) => setStatus(event.target.value)}
              size='small'
            >
              <MenuItem value={enquiryStatus.OPEN}>New</MenuItem>
              <MenuItem value={enquiryStatus.CANCELLED}>Cancelled</MenuItem>
              <MenuItem value={enquiryStatus.CONVERTED}>Converted</MenuItem>
              <MenuItem value={enquiryStatus.ONHOLD}>On Hold</MenuItem>
              <MenuItem value={enquiryStatus.RESPONDED}>Responded</MenuItem>
            </Select>
          </FormControl>
        </div>
        <div>
          <FormControl sx={sxProps.formControl}>
            <InputLabel id='event-type'>EventType</InputLabel>
            <Select
              labelId='event-type'
              id='event-type-label'
              value={eventType}
              onChange={(event) => setEventType(event.target.value)}
              size='small'
              label='EventType'
            >
              <MenuItem value={eventTypes.WEDDING}>Wedding</MenuItem>
              <MenuItem value={eventTypes.BIRTHDAY}>Birthday</MenuItem>
              <MenuItem value={eventTypes.CORPORATE}>
                Corporate Entertainment
              </MenuItem>
              <MenuItem value={eventTypes.OTHER}>Other</MenuItem>
              <MenuItem value={eventTypes.OTHERGIG}>Other Gig</MenuItem>
              <MenuItem value={eventTypes.FINNEGANS}>Finnegans Gig</MenuItem>
              <MenuItem value={eventTypes.MFSPUBGIG}>Brewhemia</MenuItem>
              <MenuItem value={eventTypes.PUBLICEVENT}>Public Event</MenuItem>
            </Select>
          </FormControl>
        </div>
        <div>
          <FormControl sx={sxProps.formControl}>
            <TextField
              required
              id='venue'
              label='VenueName'
              value={venueName}
              onChange={(event) => setVenueName(event.target.value)}
              size='small'
            />
          </FormControl>
        </div>
        <div>
          <FormControl sx={sxProps.formControl}>
            <TextField
              required
              id='location'
              label='Location'
              value={location}
              onChange={(event) => setLocation(event.target.value)}
              size='small'
            />
          </FormControl>
        </div>
        <div>
          <FormControl sx={sxProps.formControl}>
            <InputLabel id='price'>PriceBand</InputLabel>
            <Select
              labelId='price'
              id='price-label'
              value={priceType}
              onChange={(event) =>
                setPriceType(event.target.value as keyof ArtistPrice)
              }
              size='small'
              label='PriceBand'
            >
              {regionTypes.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </Grid>
      <Grid item>
        <Grid container direction='column' spacing={3}>
          <Grid item>
            <LocalisedDatePicker
              label='EventDate'
              date={eventDate}
              setDate={setEventDate}
            />
          </Grid>
          <Grid item>
            <LocalisedTimePicker
              label='StartTime'
              time={startTime}
              setTime={setStartTime}
            />
          </Grid>
          <Grid item>
            <LocalisedTimePicker
              label='EndTime'
              time={endTime}
              setTime={setEndTime}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default SetUp;
